module.exports = __webpack_public_path__ + "static/media/Email-marketing.5311c288.png";